module.exports = __webpack_public_path__ + "static/media/cy.690f4232.svg";